const DE = {
  ibanLength: 22,
};
export { DE };
